(function() {
  // Create $s object if it doesn't exist
  window.$s = window.$s || {};
  
  // Implement $s.getJson function using jQuery.getJSON
  if (!$s.getJson) {
    $s.getJson = function(params) {
      return new Promise(function(resolve, reject) {
        jQuery.getJSON(params.url)
          .done(function(data) {
            if (params.success) {
              params.success(data);
            }
            resolve(data);
          })
          .fail(function(error) {
            if (params.error) {
              params.error(error);
            }
            reject(error);
          });
      });
    };
  }

  // Implement other $s functions if they don't exist
  if (!$s.showLoadingOverlay) {
    $s.showLoadingOverlay = function() {
      var overlay = document.getElementById('loading-overlay');
      if (overlay) overlay.style.display = 'block';
    };
  }

  if (!$s.hideLoadingOverlay) {
    $s.hideLoadingOverlay = function() {
      var overlay = document.getElementById('loading-overlay');
      if (overlay) overlay.style.display = 'none';
    };
  }

  if (!$s.updateDynamicContent) {
    $s.updateDynamicContent = function(section, content) {
      if (section && content) {
        section.innerHTML = content;
      }
    };
  }

  if (!$s.globalEval) {
    $s.globalEval = function(code) {
      if (code) {
        // Search and execute only the JavaScript within <script> tags
        var scriptMatch = code.match(/<script[^>]*>([\s\S]*?)<\/script>/gi);
        if (scriptMatch) {
          scriptMatch.forEach(function(scriptTag) {
            var jsCode = scriptTag.replace(/<script[^>]*>([\s\S]*?)<\/script>/i, '$1');
            if (jsCode.trim()) {
              var script = document.createElement('script');
              script.textContent = jsCode;
              document.head.appendChild(script);
              document.head.removeChild(script);
            }
          });
        }
      }
    };
  }

  if (!$s.showOverlay) {
    $s.showOverlay = function() {
      var overlay = document.getElementById('overlay');
      if (overlay) overlay.style.display = 'block';
    };
  }

  if (!$s.hideOverlay) {
    $s.hideOverlay = function() {
      var overlay = document.getElementById('overlay');
      if (overlay) overlay.style.display = 'none';
    };
  }

  if (!$s.trapFocus) {
    $s.trapFocus = function(element, activeElement) {
      if (element && activeElement) {
        activeElement.focus();
      }
    };
  }

  if (!$s.removeTrapFocus) {
    $s.removeTrapFocus = function() {
      // Basic remove focus trap implementation
    };
  }

  if (!$s.closeModal) {
    $s.closeModal = function() {
      // Basic close modal implementation
    };
  }

  if (!$s.dispatchEvent) {
    $s.dispatchEvent = function(element, eventName) {
      if (element) {
        element.dispatchEvent(new CustomEvent(eventName));
      }
    };
  }

  if (!$s.get) {
    $s.get = function(params) {
      return new Promise(function(resolve, reject) {
        jQuery.ajax({
          url: params.url,
          type: 'GET',
          dataType: 'text'
        })
        .done(function(data) {
          if (params.success) {
            params.success(data);
          }
          resolve(data);
        })
        .fail(function(error) {
          if (params.error) {
            params.error(error);
          }
          reject(error);
        });
      });
    };
  }

  if (!$s.updateCartItemsQuantity) {
    $s.updateCartItemsQuantity = function(data) {
      return new Promise(function(resolve, reject) {
        jQuery.ajax({
          url: '/cart/update.js',
          method: 'POST',
          data: data,
          dataType: 'json'
        })
        .done(function(cart) {
          resolve(cart);
        })
        .fail(function(error) {
          reject(error);
        });
      });
    };
  }

  if (!$s.addToCartSuccess) {
    $s.addToCartSuccess = function() {
      console.log('Cart updated successfully');
    };
  }

  if (!$s.addToCartFail) {
    $s.addToCartFail = function(error) {
      console.error('Cart update failed:', error);
    };
  }

  if (!$s.getQueryParam) {
    $s.getQueryParam = function(name) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    };
  }

  if (!$s.getItemsToUpdate) { 
    $s.getItemsToUpdate = function(item, quantity) {
      return [item];
    };
  }

  if (!$s.expand) {
    $s.expand = function(elements) {
      elements.forEach(function(element) {
        if (element) element.style.display = 'block';
      });
    };
  }

  if (!$s.collapse) {
    $s.collapse = function(elements) {
      elements.forEach(function(element) {
        if (element) element.style.display = 'none';
      });
    };
  }

  if (!$s.openModal) {
    $s.openModal = function(content, className) {
      // Create a dynamic modal using the existing Modal class
      var modalId = 'dynamic-modal-' + Date.now();
      var modalHtml = `
        <div id="${modalId}" class="js-modal" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999;">
          <div class="js-modal-content" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 20px; border-radius: 8px; max-width: 500px; max-height: 80vh; overflow-y: auto;">
            <button data-modal-close="${modalId}" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 20px; cursor: pointer;">×</button>
            <div class="modal-content-wrapper"></div>
          </div>
        </div>
      `;
      
      // Add the modal to the DOM
      document.body.insertAdjacentHTML('beforeend', modalHtml);
      
      // Get the modal and content container
      var modal = document.getElementById(modalId);
      var contentWrapper = modal.querySelector('.modal-content-wrapper');
      
      // If content is a DOM element, clone it; if it's HTML, insert it
      if (content instanceof Element) {
        contentWrapper.appendChild(content.cloneNode(true));
      } else if (typeof content === 'string') {
        contentWrapper.innerHTML = content;
      }
      
      // Create a Modal instance using jQuery
      if (window.theme && window.theme.Modal && window.jQuery) {
        var $modal = window.jQuery(modal);
        var modalInstance = new window.theme.Modal($modal);
        modalInstance.open();
        
        // Clean up the modal when it closes
        $modal.on('Modal:close', function() {
          setTimeout(function() {
            if (modal && modal.parentNode) {
              modal.parentNode.removeChild(modal);
            }
          }, 300); // Wait for the animation to finish
        });
      } else {
        // Fallback if no jQuery or Modal
        modal.style.display = 'block';
        
        // Add event listener to close
        var closeBtn = modal.querySelector('[data-modal-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            modal.style.display = 'none';
            if (modal.parentNode) {
              modal.parentNode.removeChild(modal);
            }
          });
        }
        
        // Close when clicking outside the content
        modal.addEventListener('click', function(e) {
          if (e.target === modal) {
            modal.style.display = 'none';
            if (modal.parentNode) {
              modal.parentNode.removeChild(modal);
            }
          }
        });
      }
    };
  }

  if (!$s.validateBundlesInJson) {
    $s.validateBundlesInJson = function(items) {
      console.log('Validating bundles:', items);
    };
  }

  // Add missing currency functions
  if (!$s.toCartCurrency) {
    $s.toCartCurrency = function(value) {
      return Shopify.currency.rate/1!=1 ? Math.ceil(value * Shopify.currency.rate*100)/100 : value/1;
    }
  }

  if (!$s.formatMoney) {
    $s.formatMoney = function(cents, format) {
      if(typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || window.money_format || '');

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if(isNaN(number) || number == null) {return 0;}

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }
      
      // Check if formatString exists and has the expected format
      if (!formatString || typeof formatString !== 'string') {
        formatString = '';
      }
      
      var match = formatString.match(placeholderRegex);
      if (match && match[1]) {
        switch(match[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          default:
            value = formatWithDelimiters(cents, 2);
            break;
        }
        return formatString.replace(placeholderRegex, value);
      } else {
        // Fallback: just return the formatted amount
        return formatWithDelimiters(cents, 2);
      }
    }
  }

  window.SideCart = window.SideCart || new function() {
    var self = this;
    var isOpen = false;
    
    document.addEventListener('mousedown', function(event){
      var sideCart = document.getElementById('side-cart');
      if(!sideCart || (!event.target.closest('#side-cart') && event.target.id!="loading-overlay" && sideCart.classList.contains('open') && !event.target.classList.contains('tingle-modal') && !event.target.closest('.tingle-modal'))) {
        self.hideSideCart();
      }
    });

    self.isOpen = function() {
      return isOpen;
    }

    self.checkout = function() {
      window.location.href = '/checkout';
    }

    self.updateCartCount = function() {
      $s.getJson({url: '/cart.js'})
        .then(function(cart) {
          var itemCount = cart.item_count || 0;
          console.log('Updating cart count to:', itemCount);
          
          // Update cart-count elements (including badge)
          var cartCountElements = document.querySelectorAll('.cart-count');
          cartCountElements.forEach(function(element) {
            element.innerHTML = itemCount > 0 ? itemCount : '';
            console.log('Updated cart-count element:', element);
          });
          
          // Update js-cart-item-count elements
          var jsCartItemCountElements = document.querySelectorAll('.js-cart-item-count');
          jsCartItemCountElements.forEach(function(element) {
            element.innerHTML = itemCount > 0 ? itemCount : '';
            console.log('Updated js-cart-item-count element:', element);
          });
          
          // Also update theme.cart.content.item_count for consistency
          if (window.theme && window.theme.cart) {
            window.theme.cart.content.item_count = itemCount;
          }
        })
        .catch(function(error) {
          console.error('Error updating cart count:', error);
        });
    }

    self.updateSideCart = function(open) {
      if (isOpen || open) {
        $s.showLoadingOverlay();
        }
      
      $s.getJson({url: routes.root_url + '?sections=side_cart'})
        .then(async function(data) {
          var section = document.querySelector('#side-cart');
          if (section && data['side_cart']) {
            var dynamicContent = section.querySelector('[data-dynamic-content="sidecart"]');
            var dynamicFoot = section.querySelector('[data-dynamic-content="sidecart-foot"]');
            
            if (dynamicContent) {
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = data['side_cart'];
              var newDynamicContent = tempDiv.querySelector('[data-dynamic-content="sidecart"]');
              if (newDynamicContent) {
                dynamicContent.innerHTML = newDynamicContent.innerHTML;
              }
            }
            
            if (dynamicFoot) {
              var newDynamicFoot = tempDiv.querySelector('[data-dynamic-content="sidecart-foot"]');
              if (newDynamicFoot) {
                dynamicFoot.innerHTML = newDynamicFoot.innerHTML;
              }
            }
            
            var foot = section.querySelector('.foot');
            if (section.querySelector('.cart-items')) {
              foot.style.display = '';
            } else {
              foot.style.display = 'none';
            }

            $s.hideLoadingOverlay();
            
            // Update cart count after updating side cart with a small delay to ensure cart is updated
            setTimeout(function() {
              self.updateCartCount();
            }, 100);
            
            if (open && !isOpen) {
              self.showSideCart(true);
            }
            
            await $s.globalEval(data['side_cart']);
            self.addEventListeners();
          }
        })
        .catch(function(error) {
          console.error('Error updating side cart:', error);
          $s.hideLoadingOverlay();
        });
    }
    
    self.addEventListeners = function() {
      var sideCart = document.getElementById('side-cart');
      if (sideCart) {
        sideCart.addEventListener('click', function(e) {
          if (e.target.closest('.head .close')) {
            e.preventDefault();
            if (window.SideCart) {
              window.SideCart.hideSideCart();
            }
          }
        });
      }
      
      var quantityButtons = document.querySelectorAll('#side-cart .quantity-button');
      quantityButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          var quantityBox = this.closest('.quantity-box');
          var input = quantityBox.querySelector('input[type="number"]');
          var currentValue = parseInt(input.value) || 0;
          var minValue = parseInt(input.min) || 0;
          var maxValue = parseInt(input.max) || 999;
          
          if (this.classList.contains('minus')) {
            if (currentValue > minValue) {
              input.value = currentValue - 1;
              input.dispatchEvent(new Event('change'));
            }
          } else if (this.classList.contains('plus')) {
            if (currentValue < maxValue) {
              input.value = currentValue + 1;
              input.dispatchEvent(new Event('change'));
            }
          }
          
          var minusButton = quantityBox.querySelector('.quantity-button.minus');
          var plusButton = quantityBox.querySelector('.quantity-button.plus');
          if (minusButton) minusButton.disabled = (parseInt(input.value) <= minValue);
          if (plusButton) plusButton.disabled = (parseInt(input.value) >= maxValue);
        });
      });
      
      var quantityInputs = document.querySelectorAll('#side-cart .cart-items input[type=number]');
      quantityInputs.forEach(function(input) {
        input.addEventListener('change', function(e){
          var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), this.value) : [this.closest('.item')];
          if (window.SideCart) {
            window.SideCart.updateItemsQuantity(items, this.value);
          }
        });
      });
      
      var removeButtons = document.querySelectorAll('#side-cart .remove');
      removeButtons.forEach(function(button) {
        button.addEventListener('click', function(e){
          var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), 0) : [this.closest('.item')];
          if (window.SideCart) {
            window.SideCart.updateItemsQuantity(items, 0);
          }
        });
      });

      var cartPopupButtons = document.querySelectorAll('#side-cart .cart-popup-button');
      cartPopupButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          $s.openModal(this.closest('.cart-custom').querySelector('.cart-popup-text'));
          return false;
        });
      });
      
      var cartPopupLinkButtons = document.querySelectorAll('#side-cart .cart-popuplink-button');
      cartPopupLinkButtons.forEach(function(button) {
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          if (this.dataset.url) {
            $s.showLoadingOverlay();
            let content = await $s.get({url: this.dataset.url});
            $s.hideLoadingOverlay();
            $s.openModal(content, 'cart-popuplink-modal');
            $s.globalEval(content);
          }
        });
      });
      
      var cartAccordionButtons = document.querySelectorAll('#side-cart .cart-accordion-button');
      cartAccordionButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          var panel = this.closest('.cart-custom').querySelector('.expandable');
          if (this.getAttribute('aria-expanded')=='false') {
            this.setAttribute('aria-expanded', 'true');
            $s.expand([panel]);
          } else {
            this.setAttribute('aria-expanded', 'false');
            $s.collapse([panel]);
          }
          return false;
        });
      });
      
      var checkNote = document.querySelector('#side-cart #checkbox-cart-note');
      if (checkNote) {
        var checkNoteChange = function() {
          var note = document.querySelector('#side-cart #cart-note');
          if (checkNote.checked) {
            note.classList.remove('hide');
          } else {
            note.classList.add('hide');
            var textarea = note.querySelector('textarea');
            if (textarea && textarea.value != '') {
              textarea.value = '';
              $s.dispatchEvent(textarea, 'change');
            }
          }
        }
        
        var checkNoteLabel = document.querySelector('#side-cart .checkbox-cart-note-label');
        if (checkNoteLabel) {
          checkNoteLabel.addEventListener('keypress', function(event) {
            if (event.keyCode == 13) {
              checkNote.click();
            }
          });
        }
        
        checkNote.addEventListener('change', checkNoteChange);
        checkNoteChange();
      }

      var checkoutButton = document.querySelector('#side-cart .btn-checkout');
      if (checkoutButton) {
        checkoutButton.addEventListener('click', function(e) {
          e.preventDefault();
          if (window.SideCart && window.SideCart.checkout) {
            window.SideCart.checkout();
          } else {
            window.location.href = '/checkout';
          }
        });
      }
    }

    self.showSideCart = function(animate) {
      var sideCart = document.getElementById('side-cart');
      var activeElement = null;
      if (isOpen) {
        if (sideCart.contains(document.activeElement)) {
          activeElement = document.activeElement;
        }
        $s.removeTrapFocus();
      }
      $s.closeModal();

      isOpen = true;
      $s.showOverlay();
      if(animate) {
        setTimeout(function(){
          sideCart.classList.add('open'); 
          setTimeout(function() {
            $s.trapFocus(sideCart, activeElement);
          }, 50);
        }, 100);
      } else {
        sideCart.classList.remove('ease-animation');
        sideCart.classList.add('open');
        setTimeout(function(){sideCart.classList.add('ease-animation')}, 100);
        $s.trapFocus(sideCart, activeElement);
      }
      $s.dispatchEvent(sideCart, 'open');

      if (window.CartCache && CartCache.cart_fetch === null) {
        $s.get({url:'/cart.js'});
      }
    };

    self.hideSideCart = function() {
      isOpen = false;
      var sideCart = document.getElementById('side-cart');
      $s.hideOverlay();
      sideCart.classList.remove('open');
      $s.removeTrapFocus();
    };

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    async function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.updateCartItemsQuantity(data).then(async function(cart) {
        $s.addToCartSuccess();
        if (window.SideCart) {
          window.SideCart.updateSideCart(window.SideCart.isOpen());
          window.SideCart.updateCartCount();
        }
      }).catch($s.addToCartFail);
    }

    window.addEventListener('keydown', function(e){
      if (e.which == 27) {
        var sideCart = document.getElementById('side-cart');
        if(sideCart.classList.contains('open')){
          e.preventDefault();
          window.SideCart.hideSideCart();
          return false;
        }
      }
    });

    
  
    function connectTriggerCart() {
      document.querySelectorAll('.trigger-cart').forEach(function(element) {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          if (window.SideCart) {
            window.SideCart.showSideCart(true);
          } else {
            console.log('SideCart not ready, retrying...');
            setTimeout(connectTriggerCart, 100);
          }
        });
      });
    }

    document.addEventListener('cart:updated', function(event) {
      if (window.SideCart) {
        window.SideCart.updateSideCart(true);
        window.SideCart.updateCartCount();
      }
    });

    document.addEventListener('cart:added', function(event) {
      if (window.SideCart) {
        window.SideCart.updateSideCart(true);
        window.SideCart.updateCartCount();
      }
    });

    
    function loadSideCart() {
      connectTriggerCart();

      $s.getJson({url: location.pathname + location.search + (location.search ? '&':'?') + 'sections=side_cart'})
        .then(function(data) {
          if(data["side_cart"]) {
            var section = document.getElementById('shopify-section-side_cart');
            if (section) {
              section.parentNode.removeChild(section);
            }
            document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
            $s.globalEval(data["side_cart"]);
            
            if (window.SideCart) {
              window.SideCart.addEventListeners();
            }
          }
        })
        .catch(function(error) {
          console.error('Error loading side cart:', error);
        });
    }
    
    if (location.pathname.indexOf(routes.cart_url) != 0 && location.pathname.indexOf('/password') == -1) {
      loadSideCart();
    }
    
  };

  var sideCart = document.getElementById('side-cart');
  if (sideCart) {
    var itemsCount = 0;
    sideCart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
      itemsCount += item.value/1;
    });
    var cartCountElement = document.querySelector('header .cart-count');
    if(cartCountElement) {
      cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
    }

    if (window.SideCart) {
      window.SideCart.addEventListeners();
    }
    
    if ($s.validateBundlesInJson) {
      $s.getJson({url:'/cart.js'})
        .then(data => {
          $s.validateBundlesInJson(data.items);
        })
        .catch(function(error) {
          console.error('Error validating bundles:', error);
        });
    }
    
    
    if (!document.getElementById('shopify-section-side_cart') && location.pathname.indexOf('/cart') != 0 && location.pathname.indexOf('/password') == -1) {
      $s.getJson({url: location.pathname + location.search + (location.search ? '&':'?') + 'sections=side_cart'})
        .then(function(data) {
          if(data["side_cart"]) {
            document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
            $s.globalEval(data["side_cart"]);
            
            if (window.SideCart) {
              window.SideCart.addEventListeners();
            }
          }
        })
        .catch(function(error) {
          console.error('Error loading side cart section:', error);
        });
    }
    
  }
  
  // Implement FreeShippingProgress component
  class FreeShippingProgress extends HTMLElement {
    constructor() {
      super();
      var total = this.dataset.cartTotal;
      var threeshold = $s.toCartCurrency(250 * 100);
      var progress = Math.min(100, total/threeshold * 100);
      var bar = this.querySelector('.progress');
      if (progress>=100) {
        bar.classList.add('goal-achieved');
      } else {
        if(this.querySelector('[data-away-value]')){
          this.querySelector('[data-away-value]').innerHTML = $s.formatMoney(threeshold - total).replace('.00', '');
        }
      }
      this.querySelector(progress>=100 ? '.achieved' : '.away').classList.remove('hide');
      setTimeout(()=>{
        bar.style.width = progress + '%';
      }); //allow transition to work
    }
  }
  customElements.define('free-shipping-progress', FreeShippingProgress);
  
})();